import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { ExpedienteService } from '../../../services/expediente.service';
import { ExpedienteDto } from '../../../dto/expediente/expediente.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { EntidadDto } from '../../../dto/expediente/entidad.dto';
import { TipoProcesoDto } from '../../../dto/expediente/tipo-proceso.dto';
import { EstadoExpedienteDto } from '../../../dto/expediente/estado-expediente.dto';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { ListasService } from '../../../services/listas.service';
import { Router } from '@angular/router';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { SpinnerService } from '../../../services/util/spinner.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TableAction } from '../../../dto/util/table-action';
import { PoliticaTratamientoDatosPersonalesComponent } from '../../util/modal-politica/politica-tratamiento-datos-personales/politica-tratamiento-datos-personales.component';
import { TranslateService } from '@ngx-translate/core';
import { DatosAdicionalesService } from '../../util/modal-datos/services/datos-adicionales.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-gestion-expedientes',
  templateUrl: './gestion-expedientes.component.html',
  styleUrl: './gestion-expedientes.component.scss',
})
export class GestionExpedientesComponent implements OnInit, AfterViewInit {
  expedientes: ExpedienteDto[] = [];
  entidades: EntidadDto[] = [];
  tiposProceso: (TipoProcesoDto | undefined)[] = [];
  estados: EstadoExpedienteDto[] = [];
  columns: TableColumn[] = [];
  actions: TableAction[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  userData: UserDataDto = {};
  @ViewChild(PoliticaTratamientoDatosPersonalesComponent)
  politicaTratamientoDatosPersonalesComponent!: PoliticaTratamientoDatosPersonalesComponent;
  numeroIdentificacionUsuario?: string;
  filtros: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: this.tamanoPagina,
    ordenarAsc: false,
    ordenarPor: 'Radicado',
    filtros: {},
  };
  esBuscar?: boolean;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaGestionExpedienteText: any = {};
  archivosText: any = {};

  showGuia: boolean = true;

  constructor(
    private readonly expedienteService: ExpedienteService,
    private readonly listasService: ListasService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly spinnerService: SpinnerService,
    private readonly translate: TranslateService,
    private readonly datosProvisionalesService: DatosAdicionalesService
  ) {}

  ngAfterViewInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const rol = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    const tipoUsuario = rol.Nombre;
    if (
      (tipoUsuario == 'Ciudadano' || tipoUsuario == 'Abogado') &&
      infoInicioSesion.aceptoDatos == false
    ) {
      this.politicaTratamientoDatosPersonalesComponent.abrirModal();
    }
  }

  ngOnInit(): void {
    // Multilenguaje
    combineLatest({
      guia: this.translate.stream('guias-interactivas'),
      tablas: this.translate.stream('gestion-expedientes-tabla'),
      guiaExpediente: this.translate.stream('guia-gestion-expediente'),
      archivos: this.translate.stream('descarga-documentos'),
    }).subscribe(({ guia, tablas, guiaExpediente, archivos }) => {
      // Asignar traducciones a variables
      this.guiaText = guia;
      this.tableText = tablas;
      this.guiaGestionExpedienteText = guiaExpediente;
      this.archivosText = archivos;
      this.initColumns();
    });
    // Se toma la información del usuario que inicia sesión
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.obtenerNumeroIdentificacionGestor();
    this.listarExpedientes();
    this.listarEntidades();
    this.listarEstados();

    const isShowGuia =
      sessionStorage.getItem(Constants.SHOW_GUIA_EXPEDIENTE) != null
        ? false
        : this.showGuia;
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaGestionExpedienteText['titulo'],
      descripcionPantalla: this.guiaGestionExpedienteText['descripcion'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaGestionExpedienteText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaGestionExpedienteText['filtro-titulo'],
            description: this.guiaGestionExpedienteText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaGestionExpedienteText['crear-solicitud-titulo'],
            description:
              this.guiaGestionExpedienteText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaGestionExpedienteText['historico-titulo'],
            description:
              this.guiaGestionExpedienteText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Radicado',
          popover: {
            title: this.guiaGestionExpedienteText['proceso-titulo'],
            description: this.guiaGestionExpedienteText['proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#entidad',
          popover: {
            title: this.guiaGestionExpedienteText['entidad-titulo'],
            description: this.guiaGestionExpedienteText['entidad-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#tipoProceso',
          popover: {
            title: this.guiaGestionExpedienteText['tipo-proceso-titulo'],
            description:
              this.guiaGestionExpedienteText['tipo-proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Creacion',
          popover: {
            title: this.guiaGestionExpedienteText['fecha-creacion-titulo'],
            description:
              this.guiaGestionExpedienteText['fecha-creacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Ultima_Modificacion',
          popover: {
            title: this.tableText['fecha-actualizacion'],
            description:
              this.guiaGestionExpedienteText['fecha-actualizacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado',
          popover: {
            title: this.guiaGestionExpedienteText['estado-titulo'],
            description: this.guiaGestionExpedienteText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    this.datosProvisionalesService.mostrarGuia.subscribe(resp => {
      if (resp && isShowGuia) {
        this.utilService.changeInfoPantalla(this.infoPantalla);
        this.utilService.iniciarGuiaInteractiva();
        sessionStorage.setItem(Constants.SHOW_GUIA_EXPEDIENTE, 'false');
      } else {
        this.utilService.changeInfoPantalla(this.infoPantalla);
      }
    });
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    // if (this.userData.primerInicioSesion) {
    //   this.utilService.changeInfoPantalla(this.infoPantalla);
    //   this.utilService.iniciarGuiaInteractiva();
    // } else {
    //   this.utilService.changeInfoPantalla(this.infoPantalla);
    // }
    this.utilService.show();
  }

  listarExpedientes() {
    const userType = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    console.log("USER TYPE", userType)
    this.filtros.filtros.usuario = this.userData.idUsuario;
    this.filtros.filtros.tipoUsuario = userType.Id;
    this.filtros.filtros.numeroIdentificacionUsuario = this.numeroIdentificacionUsuario;
    this.expedienteService.getExpedientes(this.filtros).subscribe(data => {
      this.expedientes = data.registros;
      this.totalPaginas = data.totalPaginas;
      this.paginaActual = data.numeroPagina;
      this.tiposProceso = Array.from(
        new Map(
          data.registros.map(tp => [tp.Tipo_Proceso?.Id, tp.Tipo_Proceso])
        ).values()
      );
      this.initColumns();
    });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  listarEntidades() {
    this.listasService.getEntidades().subscribe(data => {
      this.entidades = data;
      this.initColumns();
    });
  }

  listarEstados() {
    this.listasService
      .getEstadosExpediente(this.filtros.filtros.entidad || 0)
      .subscribe(data => {
        if (this.filtros.filtros.entidad) {
          this.estados = data;
        } else {
          this.estados = data.map(estado => {
            estado.Estado = `${estado.Estado} - ${estado.Entidad?.Entidad}`;
            return estado;
          });
        }
        this.initColumns();
      });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  initColumns() {
    this.columns = [
      {
        field: 'Radicado',
        title: this.tableText['numero-proceso'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroProceso',
        width: '8rem',
        accion: (item: ExpedienteDto) => {
          if (item.Estado_Expediente?.Proceso_Finalizado) {
            this.utilService.hide();
          }
          switch (item?.Tipo_Proceso?.Entidad_Id) {
            case 1:
              if (!item?.Tipo_Proceso?.Tipo_Proceso?.includes('Insolvencia')) {
                this.router.navigate([
                  '/expediente/ssm',
                  item.Id,
                  item.Usuario_Id_Creador ?? 0,
                ]);
              } else {
                this.router.navigate([
                  '/expediente/supersociedades',
                  item.Id,
                  item.Usuario_Id_Creador ?? 0,
                ]);
              }
              break;
            case 2:
              this.router.navigate([
                '/expediente/sic/',
                item.Id,
                item.Usuario_Id_Creador ?? item.Usuario_Id ?? 0,
              ]);
              break;
            case 3:
              this.router.navigate([
                '/expediente/supersalud',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            case 4:
              this.router.navigate([
                '/expediente/superfinanciera',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            case 5:
              this.router.navigate([
                '/expediente/dnda',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            case 6:
              this.router.navigate([
                '/expediente/dimar',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            case 7:
              this.router.navigate([
                '/expediente/ica',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            case 8:
              this.router.navigate([
                '/expediente/ssm',
                item.Id,
                item.Usuario_Id_Creador ?? 0,
              ]);
              break;
            default:
              break;
          }
        },
      },
      {
        id: 'entidad',
        field: 'Tipo_Proceso.Entidad.Entidad',
        title: this.tableText['entidad'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'entidad',
        elements: this.entidades,
        option: 'Entidad',
        value: 'Id',
      },
      {
        id: 'tipoProceso',
        field: 'Tipo_Proceso.Tipo_Proceso',
        title: this.tableText['tipo-proceso'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tipoProceso',
        elements: this.tiposProceso,
        option: 'Tipo_Proceso',
        value: 'Id',
      },
      {
        field: 'Fecha_Creacion',
        title: this.tableText['fecha-creacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaCreacion',
        pipe: 'dd/MM/yyyy',
        width: '11rem',
      },
      {
        field: 'Fecha_Ultima_Modificacion',
        title: this.tableText['fecha-actualizacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaActualizacion',
        pipe: 'dd/MM/yyyy',
        width: '11rem',
      },
      {
        id: 'estado',
        field: 'Estado_Expediente.Estado',
        title: this.tableText['estado'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
    ];
    this.actions = [
      {
        type: 'button',
        icon: 'users',
        title: this.tableText['gestion-acceso'],
        idAccion: '1',
        visible: (item: ExpedienteDto) => item?.Tipo_Proceso?.Entidad_Id !== 1,
      },
    ];
  }

  gestionPermisos(event: any) {
    const id = event.item.Id;
    const radicado = event.item.Radicado;
    this.router.navigate([`/expediente/gestion-permisos/${id}/${radicado}`]);
  }

  buscar(event: FiltroDto<object>) {
    this.esBuscar = true;
    this.filtros.ordenarPor =
      event.ordenarPor == '' ? 'Radicado' : event.ordenarPor;
    this.filtros.filtros = event.filtros as ExpedienteFiltroDto;
    if (this.filtros.filtros.numeroProceso) {
      this.filtros.filtros.numeroProceso =
        this.filtros.filtros.numeroProceso.toString();
    }
    if (this.filtros.filtros.estado) {
      this.filtros.filtros.estado = +this.filtros.filtros.estado;
    }
    if (this.filtros.filtros.tipoProceso) {
      this.filtros.filtros.tipoProceso = +this.filtros.filtros.tipoProceso;
    }
    if (this.filtros.filtros.entidad) {
      this.filtros.filtros.entidad = +this.filtros.filtros.entidad;
    }
    const userType = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    this.filtros.filtros.usuario = this.userData.idUsuario;
    this.filtros.filtros.tipoUsuario = userType.Id;
    this.filtros.filtros.numeroIdentificacionUsuario = this.numeroIdentificacionUsuario;
    this.filtros.ordenarAsc = event.ordenarAsc;
    this.filtros.pagina = +(event.selectedPage ?? 1);
    this.filtros.tamanoPagina = +event.tamanoPagina;
    this.listarExpedientes();
    this.listarEstados();
  }

  obtenerNumeroIdentificacionGestor() {
    // Leer el rol completo que ya está guardado
    const userTypeStr = sessionStorage.getItem(Constants.USER_TYPE);

    if (userTypeStr) {
      const userType = JSON.parse(userTypeStr);

      // Si es gestor de empresa, obtener el NIT de empresaInfo
      if (userType.empresaInfo?.nit) {
        this.numeroIdentificacionUsuario = userType.empresaInfo.nit;
        console.log('NIT del gestor:', this.numeroIdentificacionUsuario);
      }
      else {
        const userInfo = JSON.parse(
          sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
        );
        this.numeroIdentificacionUsuario = userInfo.identificacion;
        console.log('Identificación del ciudadano/abogado/funcional:', this.numeroIdentificacionUsuario);
      }
    } else {
      console.warn('No se encontró USER_TYPE en sessionStorage');
    }
  }
}
